import React, { useCallback, useEffect, useState } from 'react';
import './requestApproval.css';
import ApprovalTable from '../../components/tableComponent/ApprovalTable';
import axios from 'axios';
import baseConfig from '../../../config/config';
import { useNavigate } from "react-router-dom";
function ApproveRequest(props) {
    const [selectedArray, setSelectedArray] = React.useState(props.data?.filter((item, index) => props.selectedIndex?.includes(item.RequestID)));
    const [success, setSuccess] = React.useState(false);
    const [resultArray, setResultArray] = React.useState([]);
    const [failed, setFailed] = React.useState(false);
    const [allocating, setAllocating] = useState(false)

    const navigate = useNavigate();
    const update = async () => {
        setAllocating(true)
        if (props.selectedIndex) {
            const filteredData = selectedArray.map((item) => ({
                RequestID: item.RequestID,
                DC_RegionAllocated: item.DC_RegionAllocated,
                GPUsAllocated: item.GPUsAllocated || 0,
                DateAllocated: item.DateAllocated,
                RequestStatus: item.RequestStatus,
                EarmarkedDate: item.EarmarkedDate,
                FullyAllocatedDate: item.FullyAllocatedDate,
                AIGBB: item.AIGBB,
                RI: item.RI,
                GPU_Name: item.GPU_Name,
            }));
            try {
                let csrfToken=localStorage.getItem("csrfToken")
                const response = await axios.post(
                    baseConfig.apiBaseUrl + '/request/manual/allocation',
                    filteredData,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            "serviceid": sessionStorage.getItem("userToken"),
                            "X-CSRF-Token": csrfToken
                        },
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    setAllocating(false)
                    const responseArray =response.data
                    setResultArray(responseArray)
                    if(responseArray.length === 0){
                        setSuccess(true)
                        setTimeout(() => {
                            setSuccess(false)
                            window.location.reload();
                        }, 3000);
                    }
                    
                }

            } catch (error) {
                console.error('API Error:', error);
                setAllocating(false)
                setFailed(true)
                setTimeout(() => {
                    setFailed(false)
                }, 3000);
                // if (error.response.status === 404) {
                //     showToast(error.response.data)
                // }
                if (error.response.status === 401) {
                    navigate("/errorPage");
                }
            }
        }
        else {
            window.location.reload();
        }
    }

    const handleEscapeKeyPress = useCallback((event) => {
        if (event.key === 'Escape') {
            props.closeConfirmationModal()
        }
      }, []);
    
      useEffect(() => {
        document.addEventListener('keydown', handleEscapeKeyPress);
    
        return () => {
          document.removeEventListener('keydown', handleEscapeKeyPress);
        };
      }, [handleEscapeKeyPress]);

    return (
        <>
            <div className="modal-container">
                <div style={{ maxHeight: '80vh' }}>
                    <div className="title">
                        <b>Approve the Request</b>
                        {!(resultArray?.length > 0) && (<i className="fa fa-times close-icon"
                            onClick={props.closeConfirmationModal}
                        ></i>)}
                    </div>

                    <hr className="divider" />
                    <div className="text" style={{ fontSize: '13.5px' }}>
                        { (resultArray.length > 0)  && (
                        <div style={{ backgroundColor: '#fdecea', color: '#b71c1c', padding: '6px', marginBottom: '10px', borderRadius: '5px' }}>
                            ⚠️ The highlighted Requests were not updated because GPUs could not be granted for the selected GPU type and region due to unavailability.
                        </div>
                        )}

                        You have selected "Manual entry" from Allocation Mode. Do you want to approve the changes? If so, please click the <b>"Approve"</b> button at the bottom of the table. If you want to cancel the request, then click the <b>"Cancel"</b> button.


                        {/* You have Selected Manual entry from Allocation Mode. Do you want to
                        Approve the Changes? If so, please Click <b>Approve</b>{' '}
                        button at the bottom of the table. If you want to cancel the request
                        then Click on <b>Cancel</b> Button. */}
                    </div>

                    <div style={{ overflow: 'scroll', maxHeight: '300px' }}>
                        <ApprovalTable data={selectedArray} result={resultArray} isMail={false}></ApprovalTable>
                    </div>

                    <hr className="divider" />

                    <div className="buttons-container">
                        {
                            (resultArray.length > 0) && (
                            <button
                                className="button button-confirm"
                                onClick={()=>window.location.reload()}
                                ><span>Ok</span>
                            </button>
                            )
                        }{
                            !(resultArray.length > 0) && (
                                <>
                                <button
                                    className="button button-go-back"
                                    onClick={props.closeConfirmationModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="button button-confirm"
                                    onClick={update}
                                    disabled={allocating ? true : false}
                                ><span>    Approve</span>

                                    <span className="tooltip-text">Confirm Allocation</span>
                                </button>
                                </>
                            )
                        }
                        
                    </div>
                </div>
            </div>
            {success && (resultArray.length === 0) && <div className="alert" style={{ backgroundColor: '#4CAF50' }}>
            Request Updated Successfully
            </div>}
            {allocating && <div className="alert" style={{ backgroundColor: '#aaaa09' }}>
                Approving...
            </div>}
            {failed && <div className="alert">
                Failed To Update Request. Try again.
            </div>}
        </>
    );
}

export default ApproveRequest;
